import loadActionTypes from "./load.types";

const INITIAL_STATE = {
  all_loads: [],
  all_loads_no: 0,
  current_page: 1,
  load_bits: [],
  loadsList_isLoading: true,
  reqInfo_isLoading: true,

  current_load: "",
};

const loadReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case loadActionTypes.SET_LOADS_LIST:
      return {
        ...state,
        all_loads: action.payload,
      };
    case loadActionTypes.SET_ALL_LOADS_NUMBER:
      return {
        ...state,
        all_loads_no: action.payload,
      };
    case loadActionTypes.SET_CURRENT_PAGE:
      return {
        ...state,
        current_page: action.payload,
      };
    case loadActionTypes.SET_LOADS_LIST_IS_LOADING:
      return {
        ...state,
        loadsList_isLoading: action.payload,
      };

    case loadActionTypes.SET_REQ_INFO_IS_LOADING:
      return {
        ...state,
        reqInfo_isLoading: action.payload,
      };

    //
    case loadActionTypes.SET_CURRENT_LOAD:
      return {
        ...state,
        current_load: action.payload,
      };

    case loadActionTypes.SET_LOAD_BITS:
      return {
        ...state,
        load_bits: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default loadReducer;
